import { BanknotesIcon } from "@heroicons/react/24/outline"
import SwitchComponent from "../asignacion-horario/subComponents/SwitchComponent"

export default function DatagridDetalleRetiro({ data=[], month, year, recordsPerPage, currentPage }) {

    return (
      <div className="px-4 sm:px-6 lg:px-8 bg-primarioMira pt-5 rounded-lg shadow-xl">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <div className="flex flex-row">
              <BanknotesIcon
                className="h-14 w-14 mr-2 text-secundario"
              />
              <div>
                <h3 className="text-lg font-semibold text-white">Detalle - Notas de crédito</h3>
                <h4 className="text-lg font-semibold text-white">{month} {year}</h4>
              </div>
            </div>
            <p className="mt-2 text-sm text-grisMira">
              Lista detallada de transacciones realizadas con nota de crédito.
            </p>
          </div>
        </div>
        <div className="mt-8 flex flex-col">
          <div className="-my-2 -mx-4 overflow-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full align-middle">
              <div className="h-auto shadow ring-1 ring-black ring-opacity-5">
                <table className="min-w-full divide-y divide-grisMira p-5">
                  <thead className="sticky top-0 bg-secundarioMira">
                    <tr className="divide-x divide-grisMira">
                      <th scope="col" className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-grisMira sm:pl-6">
                        ID
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                        Empresa
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                        Fecha
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                        Número nota de crédito
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                        Carnet
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                        Valor
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                        Aplicada
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-grisMira bg-primarioMira">
                    {data?.map((transaction, index) => (
                      <tr key={index + 1} className='divide-x divide-grisMira'>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium sm:pl-6 text-grisMira'>
                          {(index + 1) + (recordsPerPage * (currentPage - 1))}
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6'>
                            {transaction?.Empresa}
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6'>
                            {transaction?.FechaCorte}
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6'>
                            {transaction?.Usuario}
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6'>
                            {transaction?.Banco}
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6'>
                            {transaction?.CuentaBoleta}
                        </td>
                        <td className='whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6'>
                            {transaction?.Boleta}
                            <SwitchComponent
                                  label={"Habilitado"}
                                  value={true}// getter estado
                                  setHabilitado={()=>{}} // setter estado
                                  row={false}
                            />
                        </td>                      
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  